import {
  Avatar, Button, Divider, Typography,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { LogoutOutlined } from '@ant-design/icons';
import { RootState } from '../../../../../services/reduxStore';
import styles from './index.module.scss';
import { logout } from '../../../../../services/reduxStore/auth';
import { KEYCLOAK_API } from '../../../../../configs/endpoints';
import colors from '../../../../../configs/colors';

const {
  wrapperUserInfo, userInfo, logoutWrapper, changePasswordWrapper,
} = styles;

function UserPopover() {
  const dispatch = useDispatch();
  const user = useSelector(({ auth }: RootState) => auth.user);

  return (
    <>
      <div className={wrapperUserInfo}>
        <Avatar style={{ backgroundColor: colors.primary }} size="large">
          {user?.name[0] ?? 'U'}
        </Avatar>
        <div className={userInfo}>
          <Typography.Paragraph strong>{user?.name || 'User'}</Typography.Paragraph>
          <Typography.Paragraph type="secondary">{user?.email}</Typography.Paragraph>
        </div>
      </div>
      <div className={changePasswordWrapper}>
        <Button onClick={() => { window.location.href = `${KEYCLOAK_API.split('realm')[0]}/admin`; }}>Manage Account</Button>
      </div>
      <Divider />
      <div className={logoutWrapper}>
        <Button
          type="link"
          icon={<LogoutOutlined />}
          onClick={() => { dispatch(logout({})); }}
        >
          Log out
        </Button>
      </div>
    </>
  );
}

export default UserPopover;
